jQuery(document).ready(function($) {

    $('.shopify-section--image-with-text').each(function(index) {
      if (index % 2 === 1) {
        $(this).addClass('reverse-layout');
      }
    });

  setTimeout(function(){
    var body = $("body").outerWidth();
    var contain = $("header .container").innerWidth();
    var less = body - contain;
    var total = less / 2;
    $(".shopify-section--image-with-text .image-with-text .prose").css('margin-left', total);
  },300);

  setTimeout(function(){
    var body = $("body").outerWidth();
    var contain = $("header .container").innerWidth();
    var less = body - contain;
    var total = less / 2;
    $(".shopify-section--image-with-text.reverse-layout .image-with-text .prose").css('margin-right', total);
  },500);
  
});

jQuery(document).ready(function($) {

    $('header .menu-toggle svg').on('click', function() {
      $('header .menu-left .mobile-menu').addClass('active');
    });
  
    // Close mobile menu on close icon click
    $('header .menu-left .mobile-menu .icon-close').on('click', function() {
      $('header .menu-left .mobile-menu').removeClass('active');
    });

    // Content Image Section Left Margin
    if ($(window).width() > 1036) {
      var body = $("body").outerWidth();
      var contain = $(".best-selling-section .container").innerWidth();
      var less = body - contain;
      var total = less / 2;
      $(".content-image-section .left").css('margin-left', total);
   }

    // Logo Marquee Section
	var owl = $(".logo-marquee-section .owl-carousel");
	  owl.owlCarousel({
		loop: true,
		nav: false,
		responsive: {
		  0: {
			items: 2,
            margin: 20
		  },
		  768: {
			items: 3,
            margin: 50
		  },
          992: {
			items: 4,
            margin: 50
		  },
          1200: {
			items: 5,
            margin: 50
		  },
		  1500: {
			items: 6,
            margin: 130
		  }
		},
		autoplay: true,
        slideTransition: 'linear',
        autoplayTimeout: 6000,
        autoplaySpeed: 6000,
        autoplayHoverPause: true,
		dots: false,
		navText: ["<i class='fa fa-arrow-left'></i>", "<i class='fa fa-arrow-right'></i>"]
	  });

      // Best Selling Section
      var owl1 = $(".best-selling-section .owl-carousel");
	  owl1.owlCarousel({
        margin: 0,
		loop: true,
		nav: true,
		responsive: {
		  0: {
			items: 1
		  },
		  768: {
			items: 2
		  },
		  1037: {
			items: 4,
		  }
		},
		autoplay: false,
        slideTransition: 'linear',
        autoplayTimeout: 6000,
        autoplaySpeed: 6000,
        autoplayHoverPause: true,
		dots: false,
		navText: ["➜", "➜"]
	  });	

      // Header Announcement
      var owl2 = $("header .owl-carousel");
	  owl2.owlCarousel({
        items: 1,
        margin: 0,
		loop: true,
		nav: true,
		autoplay: true,
        autoplayTimeout: 3000,
        autoplaySpeed: 1000,
        autoplayHoverPause: true,
		dots: false,
		navText: ["‹", "›"]
	  });
	
});